import React from 'react';

import { FormProvider } from 'context/FormContext';
import { ListagemProvider } from 'context/ListagemContext';
import { usePermissionsContext } from 'context/PermissionsContext';
import { LocalFuncionarioFormComp, LocalFuncionarioListComp } from 'pages/complementar/local-funcionario/components';

export function LocalFuncionarioList() {
    const { hasPermission, alertNotPermission } = usePermissionsContext();

    if (!hasPermission(['COMPLEMENTAR_LOCAL_FUNCIONARIO'])) return alertNotPermission();

    return (
        <ListagemProvider>
            <LocalFuncionarioListComp />
        </ListagemProvider>
    );
}

export function LocalFuncionarioForm() {
    const { hasPermission, alertNotPermission } = usePermissionsContext();

    if (!hasPermission(['COMPLEMENTAR_LOCAL_FUNCIONARIO'])) return alertNotPermission();

    return (
        <FormProvider>
            <LocalFuncionarioFormComp />
        </FormProvider>
    );
}
